import React from 'react';
import { portfolioData } from '../data/portfolioData';

const InnerHeader = () => (
  <header className="inner-header">
    <img src={portfolioData.profile.avatar} alt="Profile" className="avatar" />
    <div className="profile-info">
      <h1>{portfolioData.profile.name}</h1>
    </div>
  </header>
);

export default InnerHeader;